import { numberToPrettyString } from '@cian/utils';

import template from './price-currency-select.jade';
import currency from '../../../../enums/currency';
import validation from '../../../../services/validation';

export default angular
  .module('cian.addForm.helperPriceCurrencySelect', [])
  .directive('cianAfHelperPriceCurrencySelect', () => ({
    scope: {},
    transclude: true,
    bindToController: {
      ad: '=',
      form: '=',
      inputName: '@',
      inputModel: '=',
      currencyModel: '=?', // ожидаем объект со свойством currency
      currencyName: '@?',
      priceLimit: '@?',
      isDisabled: '=',
      isRequired: '@?',
      validationMessages: '=?',
      useMinPriceLimit: '@?',
      placeholder: '@?',
      allowZero: '@?'
    },
    require: 'cianAfHelperPriceCurrencySelect',
    controller(deviceService) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      if (!this.ad.bargainTerms) {
        this.ad.bargainTerms = {};
      }

      this.inputPattern = angular.isDefined(this.allowZero) ? /^[0-9]+/ : /^[1-9]{1}[0-9]{0,}/;

      this.isRequired = angular.isDefined(this.isRequired) ? String(this.isRequired) === 'true' : true;

      this.currencies = currency;

      this.valueMin = 0;
      this.valueMax = this.priceLimit ? Number(this.priceLimit) : 10e9;

      const valueMaxLength = String(this.valueMax).length - 1;

      let defaultValidationMessages = {
        parse: 'Введите целое число',
        min: 'Цена не может быть отрицательной',
        max: `Допустимо не более ${numberToPrettyString(this.valueMax)} ₽`,
        maxlength: `Допустимо не более ${numberToPrettyString(this.valueMax)} ₽`,
        pattern: `Укажите, что "бесплатно"`,
        required: 'Не указана стоимость',
      };

      // Число выбрано исходя из сообщений выше
      const MAX_VALIDATION_MESSAGE_LENGTH_FOR_TOOLTIP = 50;

      this.shouldTooltipOpen = () => this.priceValidation.message().length <= MAX_VALIDATION_MESSAGE_LENGTH_FOR_TOOLTIP;

      this.priceValidation = validation(this.form, this.inputName, (key) => {
        return this.validationMessages ? (this.validationMessages[key] || defaultValidationMessages[key]) : defaultValidationMessages[key];
      });

      this.isPriceLimitInvalid = () => this.form && this.form[this.inputName] && this.form[this.inputName].$error && this.form[this.inputName].$error.priceLimit;

      this.priceValidationInvalid = () => {
        return this.isPriceLimitInvalid() ? false : this.priceValidation.invalid();
      };

      if (angular.isUndefined(this.currencyModel)) {
        this.currencyModel = this.ad.bargainTerms;
      }

      if (angular.isUndefined(this.currencyName)) {
        this.currencyName = 'bargainTerms.currency';
      }
    },
    link(scope, element, attrs, ctrl) {
      ctrl.currencyModel.currency = ctrl.currencyModel.currency || ctrl.currencies[0].key;
      scope.$watch(() => ctrl.isDisabled, disabled => {
        ctrl.isDisabledParsed = angular.isDefined(disabled) ? String(disabled) === 'true' : false;
      });

      attrs.$observe('useMinPriceLimit', input => {
        ctrl.useMinPriceLimit = input;
      });
    },
    controllerAs: 'priceCurrencySelect',
    template,
  }))
  .name;
